export default "__VITE_ASSET__DbudHHBT__"